<div
    [cpDisabled]="disabled"
    class="color-picker-input"
    [colorPicker]="color"
    (colorPickerChange)="onColorChange($event)"
    [style.background]="color"
    [class.disabled]="disabled"
></div>